var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBedOrSleep = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.898 5c.672 0 1.215.543 1.215 1.214v9.715h8.5V9.857c0-.672.542-1.214 1.214-1.214h8.5a3.644 3.644 0 0 1 3.643 3.643v8.5c0 .671-.543 1.214-1.215 1.214a1.213 1.213 0 0 1-1.214-1.214V19.57H4.113v1.215c0 .671-.543 1.214-1.215 1.214a1.213 1.213 0 0 1-1.214-1.214V6.214C1.684 5.543 2.227 5 2.898 5zm5.465 3.643a3.036 3.036 0 1 1 0 6.071 3.036 3.036 0 0 1 0-6.071z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBedOrSleep, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-bed-or-sleep.3f0c6390.svg";
export { ForwardRef as ReactComponent };